import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Home from './Home'
import { FaGithub } from 'react-icons/fa6'
export default function Project() {
    return (
        <>
            <section >
                <Container className='project'>
                    <Home />
                    <Container className='about-project'>
                        <h1 className='project-heading'>
                            Project
                        </h1>
                        <p>Coding Dreams into Reality <strong><span style={{ color: "#21bdbf" }}>Building </span></strong>
                            Tomorrow's Solutions Today 💻🛠️</p>
                        <Row className='project-detail'>
                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="portfolio.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Personal Portfolio</h1>
                                        <p className='card-info'>I have created my portfolio wwhich have all the information
                                            about me .I have used Reactjs to build this project </p>
                                        <a href="https://github.com/Deepali-sardana/My-Personal-Portfolio." target=' '>
                                            <FaGithub className='social-icon' /></a>
                                    </div>
                                </div>
                            </Col>

                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="voiceassistant.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Voice Assistant</h1>
                                        <p className='card-info'>I have created Voice assiatant using python modules
                                            which take some command and react accordding to it it is specially for my pc in which i have
                                            given the path of few applications present in my pc</p>
                                        <a href="https://github.com/Deepali-sardana/python-projects/blob/main/jarvis_voice_assistant.py" target=' '>
                                            <FaGithub className='social-icon' /></a>
                                    </div>

                                </div>
                            </Col>


                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="python.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Small Python Projects</h1>
                                        <p className='card-info'>I have created some small python projects
                                            like gui calculator,gui digital clock,image resizer,qr code generator,tambola game,and
                                            guo dice simulator these are beginner friendly projects</p>
                                        <a href='https://github.com/Deepali-sardana/python-projects' target=' '>
                                            <FaGithub className='social-icon' /></a>
                                    </div>

                                </div>
                            </Col>


                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="clone.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Youtube UI Clone</h1>
                                        <p className='card-info'>I have created youtube ui clone which have the features like
                                            search functionality,video thumbnail display etc .It is on Reactjs and Tailwind css
                                            and also user friendly</p>
                                        <a href='https://github.com/Deepali-sardana/Youtube-UI-Clone' target=" "><FaGithub className='social-icon' /></a>
                                    </div>

                                </div>
                            </Col>
                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="snake.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Classic Snake Game</h1>
                                        <p className='card-info'>I've created a classic Snake game
                                            built using ReactJS. Leveraging the power of React's component-based
                                            architecture.I designed an intuitive and responsive interface, allowing players
                                            to control the snake with ease.</p>
                                        <a href='https://github.com/Deepali-sardana/Classic-snake-game' target=' '><FaGithub className='social-icon' /></a>
                                    </div>

                                </div>
                            </Col>


                            <Col md={4} className='project-content' >
                                <div className='card1'>

                                    <img src="ecommerce.jpg" className='card-img' alt=''></img>
                                    <div className='card1-body'>
                                        <h1 className='card-title'>Ecommerce Website</h1>
                                        <p className='card-info'>I have created a dynamic and user-friendly e-commerce website
                                            frontend using React.js. Leveraging React's component-based architecture, I crafted a
                                            seamless browsing experience for customers</p>
                                        <a href='https://github.com/Deepali-sardana/Ecommerce-Website' target='  '>
                                            <FaGithub className='social-icon' /></a>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
        </>
    )
}
